import "core-js/modules/es.array.concat";
import "core-js/modules/web.timers";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import Global from "../common/Global";
import { toQueryString } from "../utils";
var BASE_URL = 'http://gm.mmstat.com/fsp.1.1';

var track = function track(options) {
  var trackable = Global.get('trackable');
  var version = Global.get('version');

  if (!trackable) {
    return;
  }

  var _window = window,
      location = _window.location,
      navigator = _window.navigator;
  var image = new Image();
  var params = toQueryString(_objectSpread({
    pid: 'ggeditor',
    code: '11',
    msg: 'syslog',
    page: "".concat(location.protocol, "//").concat(location.host).concat(location.pathname),
    hash: location.hash,
    ua: navigator.userAgent,
    rel: version
  }, options));
  image.src = "".concat(BASE_URL, "?").concat(params);
};

export default (function (options) {
  setTimeout(function () {
    track(options);
  }, 1000);
});